import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.css";

export default function ScrollTopButton() {
  const [intercomBooted, setIntercomBooted] = useState(false);
  const [zendeskBooted, setZendeskBooted] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [isRawData, setIsRawData] = useState(false);
  const scrollableElement = !isRawData
    ? window
    : document.querySelector(".raw-data-table .hot__flex .ht_master .wtHolder");

  useEffect(() => {
    document.addEventListener("raw-data-loaded", handleShowButton, { once: true });
    scrollableElement.addEventListener("scroll", scrollHandler);

    checkForIntercom();
    checkForZendesk();

    return () => {
      scrollableElement.removeEventListener("scroll", scrollHandler);
    };
  }, [isRawData]);

  function waitForWidgetsBoot(integrationCheck, bootCallback) {
    const timeout = setTimeout(() => clearInterval(interval), 30000);
    const interval = setInterval(() => {
      if (integrationCheck()) {
        bootCallback();
        clearInterval(interval);
        clearTimeout(timeout);
      }
    }, 100);
  }

  function checkForIntercom() {
    waitForWidgetsBoot(
      () => window.Intercom && window.Intercom.booted,
      () => setIntercomBooted(window.Intercom.booted)
    );
  }

  function checkForZendesk() {
    waitForWidgetsBoot(
      () => window.zEACLoaded,
      () => setZendeskBooted(window.zEACLoaded)
    );
  }

  function handleShowButton() {
    setIsRawData(true);
  }

  function scrollHandler() {
    const scrollY = scrollableElement.scrollY || scrollableElement.scrollTop;
    setScrollHeight(scrollY);
  }

  function onClick() {
    const scrollX = scrollableElement.scrollX || scrollableElement.scrollRight;
    scrollableElement.scrollTo(scrollX, 0);
  }

  const classes = [styles.ScrollTopButton];

  if (intercomBooted || zendeskBooted) {
    classes.push(styles.showLeft);
  }

  if (scrollHeight > 0) {
    classes.push(styles.show);
  }

  return (
    <div className={classes.join(" ")} onClick={onClick} role="button">
      <FontAwesomeIcon size="2x" icon={faArrowUp} />
    </div>
  );
}
